import React from 'react'
import { IconButton } from '@mui/material'
import ClearRoundedIcon from "@mui/icons-material/ClearRounded";

const CoreIconDelete = ({ onDelete }) => {
    return (
        <div className="absolute top-2 right-2 w-fit">
            <IconButton
                onClick={onDelete}
                className="bg-red-700 text-white w-6 h-6"
            >
                <ClearRoundedIcon className="w-3 h-3" />
            </IconButton>
        </div>
    )
}

export default CoreIconDelete